import PovButton from "@/components/button/pov-button";
import Image from "src/components/image";

export default function ModelViewerSideControl() {
  return (
    <div className="flex w-full justify-end p-[20px] pb-[30px]">
      <div className="flex flex-col gap-4">
        <PovButton />
      </div>
    </div>
  );
}
